import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, input, output, signal } from "@angular/core";

import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { ModalModule } from "ngx-bootstrap/modal";
import { DocumentStorageComponent } from "./document-storage/document-storage.component";
import { BlastHistoryComponent } from "./blast-history/blast-history.component";
import { Dossier } from "src/app/bo/dossier";
import { WorkflowEtapeInstance } from "src/app/bo/workflowEtapeInstance";

@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    TranslateModule,
    ModalModule,
    DocumentStorageComponent,
    BlastHistoryComponent
]
})
export class GeneralComponent implements OnInit, OnDestroy, OnChanges {
  readonly tirId = input<number>();
  readonly racine = input<Dossier>();
  readonly apiEndPoint = input<string>("");
  readonly securityIsChange = output<WorkflowEtapeInstance>();

  public isBlastHistoryCollapsed = signal(false);
  
  constructor() {}
  
  ngOnChanges(changes: SimpleChanges): void {
    // Les changements sont maintenant gérés par les composants enfants
  }
  
  ngOnInit() {
    // L'initialisation est maintenant gérée par les composants enfants
  }

  ngOnDestroy() {
    // Le nettoyage est maintenant géré par les composants enfants
  }
  
  onBlastHistoryCollapseChanged(isCollapsed: boolean): void {
    this.isBlastHistoryCollapsed.set(isCollapsed);
  }
}
